/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Legacy_Search_EmptyInputs */

const vi_carrier_legacy_search_empty = /** @type {(inputs: Carrier_Legacy_Search_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy xã/phường cũ nào`)
};

/**

* @param {Carrier_Legacy_Search_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_search_empty = /** @type {((inputs?: Carrier_Legacy_Search_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_Search_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_search_empty(inputs)
});